module.exports = __webpack_public_path__ + "img/login.4448b8de.png";